// The helper tools in force in the league on screen (RULES_SCHEMA §15c,
// PLAN-2026-10-29-helper-tools-switch §3).
//
// A real league's are on its card's `LeagueRef.tools`, the server's answer; the
// practice league's are its own rules', read the same way (`toolsRefOf`). A
// screen reads this to leave out a column or a card the league turned off,
// rather than drawing the dash a withheld figure would otherwise get; what is
// off is withheld by the server either way.

import { ALL_TOOLS, toolsRefOf, type ToolsRef } from '@fsp/domain';
import { useActiveLeague } from './LeaguesProvider';
import { useLeagueSource } from './leagueSource';
import { useSim } from './SimProvider';

export function useTools(): ToolsRef {
  const card = useActiveLeague();
  const source = useLeagueSource();
  const { state } = useSim();
  if (card !== null) return card.league.tools;
  if (source === 'sim') return toolsRefOf(state.settings);
  return ALL_TOOLS;
}
